<tax-page-header
  [showBackButton]="true"
  [titleText]="isXReport ? 'kkms.kkm.report.reportType.x' : 'kkms.kkm.report.reportType.z'"
></tax-page-header>

<div class="layout-2-corner-column">
  <span class="start-column tall-text" data-qa="report-id">ID {{ model?.transactionId }}</span>
  <a
    class="end-column download link_active"
    target="_blank"
    href="/api/report/{{ model?.transactionId }}/get-pdf?reportDate={{ model?.transactionDate }}"
    data-qa-link="pdf-report"
  >
    <svg-icon key="download"></svg-icon>
  </a>
</div>

<div class="ticket" data-qa="report">
  <div class="ticket__center">
    <div>
      <div class="line-space" data-qa="organization-name">{{ organisation?.fullTitle }}</div>
      <div class="line-space" data-qa="organization-iin">
        {{ 'organization.iin-bin' | translate }}: {{ organisation?.inn }}
      </div>
      <div class="line-space" *ngIf="kkm?.serialNumber" data-qa="kkm-serial-number">
        {{ 'ticket.kkm.serial.number' | translate }}: {{ kkm?.serialNumber }}
      </div>
      <div class="line-space" data-qa="report-type">
        <ng-container *ngIf="isXReport">{{
          'kkms.kkm.report.reportType.x' | translate
        }}</ng-container>
        <ng-container *ngIf="!isXReport">{{
          'kkms.kkm.report.reportType.z' | translate
        }}</ng-container>
      </div>
      <div class="line-space">
        <span translate data-qa="transaction-date">{{
          model?.transactionDate | date: 'dd.MM.yyyy / HH:mm'
        }}</span>
      </div>
      <div class="line-space" data-qa="shift-number">
        {{ 'kkm.shift.number' | translate }}
        {{ model?.shiftNumber }}
      </div>
    </div>
  </div>

  <hr class="dashed" />

  <div>
    <p class="bold-text" translate data-qa="sections-title">kkms.kkm.report.sections.title</p>
    <div *ngFor="let section of model?.zxReport.sections" data-qa-block="section">
      <div class="middle-font line-space" data-qa="section-code">
        {{ 'kkms.kkm.report.sections.section.title' | translate }} {{ section.sectionCode }}
      </div>
      <div
        class="layout-2-equals-column line-space"
        *ngFor="let operation of section.operations"
        data-qa="section-operation"
      >
        <div>
          <span class="operation_count" *ngIf="operation?.count" data-qa="operation-count">{{
            operation.count
          }}</span>
          <tax-operations [operation]="operation"></tax-operations>
        </div>
        <div class="text-right" data-qa="operation-sum">
          {{ operation.sum | kzCurrencyDecimal }}
        </div>
      </div>
    </div>

    <div *ngIf="model?.zxReport?.sectionsResult?.length" data-qa="section-results">
      <p class="bold-text" translate data-qa="section-title">kkms.kkm.report.sections.result</p>
      <div
        class="layout-2-equals-column line-space"
        *ngFor="let operation of model?.zxReport.sectionsResult"
        data-qa="section-operation"
      >
        <div>
          <span class="operation_count" *ngIf="operation?.count" data-qa="operation-count">{{
            operation.count
          }}</span>
          <tax-operations [operation]="operation"></tax-operations>
        </div>
        <div class="text-right" data-qa="operation-sum">
          {{ operation.sum | kzCurrencyDecimal }}
        </div>
      </div>
    </div>

    <div *ngIf="model?.zxReport?.discounts?.length" data-qa="section-discounts">
      <p class="bold-text" translate data-qa="section-title">kkms.kkm.report.sections.discounts</p>
      <div
        class="layout-2-equals-column line-space"
        *ngFor="let operation of model?.zxReport.discounts"
        data-qa="section-operation"
      >
        <div>
          <span class="operation_count" *ngIf="operation?.count" data-qa="operation-count">{{
            operation.count
          }}</span>
          <tax-operations [operation]="operation"></tax-operations>
        </div>
        <div class="text-right" data-qa="operation-sum">
          {{ operation.sum | kzCurrencyDecimal }}
        </div>
      </div>
    </div>

    <div *ngIf="model?.zxReport?.markups?.length" data-qa="section-markups">
      <p class="bold-text" translate data-qa="section-title">kkms.kkm.report.sections.markups</p>
      <div
        class="layout-2-equals-column line-space"
        *ngFor="let operation of model?.zxReport.markups"
        data-qa="section-operation"
      >
        <div>
          <span class="operation_count" *ngIf="operation?.count" data-qa="operation-count">{{
            operation.count
          }}</span>
          <tax-operations [operation]="operation"></tax-operations>
        </div>
        <div class="text-right" data-qa="operation-sum">
          {{ operation.sum | kzCurrencyDecimal }}
        </div>
      </div>
    </div>

    <div *ngIf="model?.zxReport?.totalResult?.length" data-qa="section-total-results">
      <p class="bold-text" translate data-qa="section-title">
        kkms.kkm.report.sections.totalResult
      </p>
      <div
        class="layout-2-equals-column line-space"
        *ngFor="let operation of model?.zxReport.totalResult"
        data-qa="section-operation"
      >
        <div>
          <span class="operation_count" *ngIf="operation?.count" data-qa="operation-count">{{
            operation.count
          }}</span>
          <tax-operations [operation]="operation"></tax-operations>
        </div>
        <div class="text-right" data-qa="operation-sum">
          {{ operation.sum | kzCurrencyDecimal }}
        </div>
      </div>
    </div>

    <p *ngIf="model?.zxReport?.taxes?.length" class="bold-text" translate data-qa="taxes-title">
      kkms.kkm.report.taxes.title
    </p>
    <div *ngFor="let tax of model?.zxReport.taxes" data-qa-block="tax">
      <div class="layout-2-equals-column line-space">
        <span translate data-qa="tax-title">kkms.kkm.report.taxes.tax.title</span>
        <span class="text-right">
          <span data-qa="tax-percent">{{ tax.taxLayout.rate * 100 | number: '1.2-2' }}%</span>
          <span data-qa="tax-type"> {{ tax.taxLayout.type }}</span>
        </span>
      </div>
      <div
        class="line-space"
        *ngFor="let operation of tax.taxOperations"
        data-qa-block="tax-operation"
      >
        <div class="layout-3-equals-column line-space">
          <span *ngIf="operation?.operation === 'SELL'" translate data-qa="sell"
            >kkms.kkm.report.operation.operationType.sell</span
          >
          <span *ngIf="operation?.operation === 'BUY'" translate data-qa="buy"
            >kkms.kkm.report.operation.operationType.buy</span
          >
          <span *ngIf="operation?.operation === 'SELL_RETURN'" translate data-qa="sell-return"
            >kkms.kkm.report.operation.operationType.sell_return</span
          >
          <span *ngIf="operation?.operation === 'BUY_RETURN'" translate data-qa="buy-return"
            >kkms.kkm.report.operation.operationType.buy_return</span
          >
          <span class="grey-text" translate data-qa="tax-turnover"
            >kkms.kkm.report.taxes.tax.turnover</span
          >
          <span class="text-right" data-qa="tax-turnover-sum">{{
            operation.turnOver | kzCurrencyDecimal
          }}</span>
        </div>
        <div class="layout-3-equals-column line-space">
          <span></span>
          <span class="grey-text" translate data-qa="tax-title"
            >kkms.kkm.report.taxes.tax.title</span
          >
          <span class="text-right" data-qa="operation-sum">{{
            operation.sum | kzCurrencyDecimal
          }}</span>
        </div>
      </div>
    </div>

    <hr class="dashed" />
    <p class="bold-text" *ngIf="isXReport" translate data-qa="report-description">
      kkms.kkm.report.reportType.x.desc
    </p>
    <p class="bold-text" *ngIf="!isXReport" translate data-qa="report-description">
      kkms.kkm.report.reportType.z.desc
    </p>
    <div class="layout-2-equals-column line-space">
      <div translate data-qa="start-shift-sell-text">
        kkms.kkm.report.nonNullableSumsOnStartShift.sells
      </div>
      <div class="text-right" data-qa="start-shift-sell-sum">
        {{ model?.zxReport?.nonNullableSumsOnStartShift.sells | kzCurrencyDecimal }}
      </div>
    </div>
    <div class="layout-2-equals-column line-space">
      <div translate data-qa="start-shift-buy-text">
        kkms.kkm.report.nonNullableSumsOnStartShift.buy
      </div>
      <div class="text-right" data-qa="start-shift-buy-sum">
        {{ model?.zxReport?.nonNullableSumsOnStartShift.buy | kzCurrencyDecimal }}
      </div>
    </div>
    <div class="layout-2-equals-column line-space">
      <div translate data-qa="start-shift-sell-return-text">
        kkms.kkm.report.nonNullableSumsOnStartShift.sellReturns
      </div>
      <div class="text-right" data-qa="start-shift-sell-return-sum">
        {{ model?.zxReport?.nonNullableSumsOnStartShift.sellReturns | kzCurrencyDecimal }}
      </div>
    </div>
    <div class="layout-2-equals-column line-space">
      <div translate data-qa="start-shift-buy-return-text">
        kkms.kkm.report.nonNullableSumsOnStartShift.buyReturns
      </div>
      <div class="text-right" data-qa="start-shift-buy-return-sum">
        {{ model?.zxReport?.nonNullableSumsOnStartShift.buyReturns | kzCurrencyDecimal }}
      </div>
    </div>
    <div
      *ngFor="let operation of model?.zxReport?.ticketOperations"
      data-qa-block="ticket-operation"
    >
      <div>
        <hr class="solid" />
      </div>
      <div class="layout-2-equals-column line-space">
        <span *ngIf="operation?.type === 'SELL'" translate data-qa="operation-sell"
          >kkms.kkm.report.ticketsType.sell</span
        >
        <span *ngIf="operation?.type === 'BUY'" translate data-qa="operation-buy"
          >kkms.kkm.report.ticketsType.buy</span
        >
        <span *ngIf="operation?.type === 'SELL_RETURN'" translate data-qa="operation-sell-return"
          >kkms.kkm.report.ticketsType.sell_return</span
        >
        <span *ngIf="operation?.type === 'BUY_RETURN'" translate data-qa="operation-buy-return"
          >kkms.kkm.report.ticketsType.buy_return</span
        >
        <span class="text-right" data-qa="total-tickets-count">{{
          operation?.totalTicketsCount
        }}</span>
      </div>
      <div class="layout-2-equals-column line-space bold-text">
        <span data-qa="tickets-count">{{ operation?.ticketsCount }}</span>
        <span data-qa="sum" class="text-right">{{ operation?.sum | kzCurrencyDecimal }}</span>
      </div>
      <div *ngFor="let payment of operation?.payments" data-qa-block="payment">
        <div class="layout-2-equals-column line-space">
          <span *ngIf="payment?.paymentType === 'CASH'" translate data-qa="cash"
            >kkms.kkm.report.payment.paymentType.cash</span
          >
          <span *ngIf="payment?.paymentType === 'CARD'" translate data-qa="card"
            >kkms.kkm.report.payment.paymentType.card</span
          >
          <span *ngIf="payment?.paymentType === 'CREDIT'" translate data-qa="credit"
            >kkms.kkm.report.payment.paymentType.credit</span
          >
          <span *ngIf="payment?.paymentType === 'MOBILE'" translate data-qa="mobile"
            >kkms.kkm.report.payment.paymentType.mobile</span
          >
          <span *ngIf="payment?.paymentType === 'TARE'" translate data-qa="tare"
            >kkms.kkm.report.payment.paymentType.tare</span
          >
          <span class="text-right" data-qa="payment-sum">{{
            payment?.sum | kzCurrencyDecimal
          }}</span>
        </div>
      </div>
    </div>

    <hr class="dashed" />

    <div
      *ngFor="let moneyPlacement of model?.zxReport?.moneyPlacements"
      data-qa-block="money-placement"
    >
      <div class="layout-2-equals-column line-space">
        <span *ngIf="moneyPlacement?.operation === 'DEPOSIT'" translate data-qa="deposit-title"
          >kkms.kkm.report.moneyPlacement.operation.deposit</span
        >
        <span
          *ngIf="moneyPlacement?.operation === 'WITHDRAWAL'"
          translate
          data-qa="withdrawal-title"
          >kkms.kkm.report.moneyPlacement.operation.withdrawal</span
        >
        <span class="text-right" data-qa="withdrawal-title">{{ moneyPlacement?.totalCount }}</span>
      </div>
      <div class="layout-2-equals-column line-space">
        <span data-qa="money-placement-count">{{ moneyPlacement?.count }}</span>
        <span data-qa="money-placement-sum" class="text-right">{{
          moneyPlacement?.sum | kzCurrencyDecimal
        }}</span>
      </div>
    </div>

    <hr class="dashed" />

    <div class="layout-2-equals-column line-space">
      <div translate data-qa="annulled-tickets-title">kkms.kkm.report.annulledTickets</div>
      <div class="text-right" data-qa="annulled-tickets-total-count">
        {{ model?.zxReport?.annulledTickets.totalCount }}
      </div>
    </div>
    <div class="layout-2-equals-column line-space">
      <div class="middle-font" data-qa="annulled-tickets-count">
        {{ model?.zxReport?.annulledTickets.count }}
      </div>
      <div></div>
    </div>
    <div
      class="layout-2-equals-column line-space"
      *ngFor="let operation of model?.zxReport?.annulledTickets.operation"
      data-qa-block="annulled-tickets-operation"
    >
      <div>
        <span *ngIf="operation?.count" data-qa="annulled-tickets-operation-count">{{
          operation.count
        }}</span>
        <tax-operations [operation]="operation"></tax-operations>
      </div>
      <span class="text-right" data-qa="annulled-tickets-total-operation-sum">{{
        operation.sum | kzCurrencyDecimal
      }}</span>
    </div>

    <hr class="dashed" />

    <div class="layout-2-equals-column line-space">
      <span translate data-qa="report-cash-title">kkms.kkm.report.cashSum</span>
      <span class="text-right" data-qa="report-cash-sum">{{
        model?.zxReport?.cashSum | kzCurrencyDecimal
      }}</span>
    </div>
    <div class="layout-2-equals-column line-space">
      <span translate data-qa="report-cash-revenue-title">kkms.kkm.report.revenue</span>
      <span class="text-right" data-qa="report-cash-revenue-sum">{{
        model?.zxReport?.revenue | kzCurrencyDecimal
      }}</span>
    </div>
    <div class="layout-2-equals-column line-space">
      <span translate data-qa="non-nullable-sell-title">kkms.kkm.report.nonNullableSums.sells</span>
      <span class="text-right" data-qa="non-nullable-sell-sum">{{
        model?.zxReport?.nonNullableSums.sells | kzCurrencyDecimal
      }}</span>
    </div>
    <div class="layout-2-equals-column line-space">
      <span translate data-qa="non-nullable-buy-title">kkms.kkm.report.nonNullableSums.buy</span>
      <span class="text-right" data-qa="non-nullable-sum">{{
        model?.zxReport?.nonNullableSums.buy | kzCurrencyDecimal
      }}</span>
    </div>
    <div class="layout-2-equals-column line-space">
      <span translate data-qa="non-nullable-sell-return-title"
        >kkms.kkm.report.nonNullableSums.sellReturns</span
      >
      <span class="text-right" data-qa="non-nullable-sell-return-sum">{{
        model?.zxReport?.nonNullableSums.sellReturns | kzCurrencyDecimal
      }}</span>
    </div>
    <div class="layout-2-equals-column line-space">
      <span translate data-qa="non-nullable-buy-return-title"
        >kkms.kkm.report.nonNullableSums.buyReturns</span
      >
      <span class="text-right" data-qa="non-nullable-buy-return-sum">{{
        model?.zxReport?.nonNullableSums.buyReturns | kzCurrencyDecimal
      }}</span>
    </div>
  </div>
</div>
